import { useEffect } from 'react';

export default function useOutsideClick(callback, innerReferences = []) {
  const handler = (event) => {
    if (
      innerReferences.every(
        (ref) => ref.current && !ref.current.contains(event.target),
      )
    ) {
      callback();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);

    return () => {
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, []);
}
